import { useCallback, useEffect, useRef, useState } from 'react';

import { IEmail } from '../../interfaces';
import { useDispatch } from '../../utils';
import { sendEmail } from './actions';

export function useSendEmail() {
  const dispatch = useDispatch();

  return useCallback(
    (email: IEmail) => {
      dispatch(sendEmail({ email }));
    },
    [dispatch],
  );
}

export function useCopyToClipboard(text: string): [boolean, () => void] {
  const [isCopied, setIsCopied] = useState(false);
  const copyText = useCallback(() => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
  }, [text]);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isCopied) {
      timeout = setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    }

    return () => clearTimeout(timeout);
  }, [isCopied]);

  return [isCopied, copyText];
}

export function useWindowResized() {
  const [isResized, setIsResized] = useState(false);
  const debouceTimeoutRef = useRef<NodeJS.Timeout>();
  const callback = useCallback(() => {
    clearInterval(debouceTimeoutRef.current);

    debouceTimeoutRef.current = setTimeout(() => {
      setIsResized(!isResized);
    }, 200);
  }, [isResized]);

  useEffect(() => {
    window.addEventListener('resize', callback);

    return () => {
      window.removeEventListener('resize', callback);
    };
  }, [callback]);

  return isResized;
}
